import { cancelTokenRefreshOnLogout } from 'services/auth/tokenBroker';
import { LocalStorage } from 'services/storage/LocalStorage';
import { LocalStorageManager } from 'services/storage/LocalStorageManager';
import { shouldClearOnLogout } from 'services/storage/policies';
import { logError } from 'setup/logger/logError';

/**
 * Clears cached auth credentials before SW/Auth0 logout.
 * `cancelTokenRefreshOnLogout` runs on every path so in-flight refresh cannot
 * repopulate a stale JWT after the user signs out.
 */
export function performLogoutLocalCleanup(clearAllLocalStorage: boolean): void {
  if (clearAllLocalStorage) {
    LocalStorage.clear();
  }
  // Always explicit: partial logout depends on this; full clear already wiped
  // storage but keeps intent obvious if LocalStorage.clear() implementation changes.
  LocalStorageManager.clearAuthToken();
  cancelTokenRefreshOnLogout();
}

export function clearLocalStorageOnLogout(): void {
  try {
    LocalStorage.clearMatching(shouldClearOnLogout);
  } catch (error) {
    logError('Failed to clear localStorage on logout', error);
  }
}
